export const APP_VERSION = "1.9.7";
export const RELEASE_DATE = "13 de Abril 2026";
export const RELEASE_NOTES = [
    "Unificación de lógica en backend para que los reportes de Emergencias, Detallado y Regional (tanto en vista como en exportación Excel) filtren consistentemente por la Fecha de Atención (Reportada) en lugar de la Fecha Resuelta."
];
